import IonAlert from '../../../../../components/Modal/ModalAlert';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonContent, IonHeader, IonIcon, IonLoading, IonModal, IonPage, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, checkmarkCircleOutline, closeCircleOutline, copyOutline, documentTextOutline, openOutline, printOutline, searchOutline, shareOutline, warningOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { MessageContext } from '../../../../../contexts/MessageContext';
import {
    fiscalBuscarNFCePorChave,
    fiscalCancelarNFCe,
    fiscalConsultarNFCe,
    fiscalReimprimirNFCe,
    requestService
} from '../../../../../Utils/Services';
import GridStatus from '../../../../../components/Grid/GridStatus';
import ModalHeader from '../../../../../components/Modal/ModalHeader';
import './FiscalDetalhes.css';

type Props = {
    abrirMenu: boolean;
};

const FiscalDetalhes: React.FC<Props> = (props: Props) => {
    const history = useHistory();
    const location = useLocation<{ nota?: any }>();
    const { loja } = useContext(MessageContext);
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);

    const [nota, setNota] = useState<any>(location.state?.nota || null);
    const [showLoading, setShowLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Carregando...");
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");
    const [toastColor, setToastColor] = useState("success");

    // Reimpressão
    const [loadingReimprimir, setLoadingReimprimir] = useState(false);

    // Cancelamento
    const [showCancelAlert, setShowCancelAlert] = useState(false);
    const [justificativa, setJustificativa] = useState("");
    const [showJustificativaModal, setShowJustificativaModal] = useState(false);

    // Status SEFAZ
    const [statusSefaz, setStatusSefaz] = useState<any>(null);
    const [showStatusModal, setShowStatusModal] = useState(false);

    const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
        setNomeMenu("");
        if (nota?.chave) {
            buscarNotaPorChave(nota.chave);
        }
    });

    function buscarNotaPorChave(chave: string) {
        requestService(
            fiscalBuscarNFCePorChave.url.replace("{chave}", chave),
            { method: fiscalBuscarNFCePorChave.method, credentials: 'include' },
            history,
            (response: any) => {
                setNota(response.dados || response);
            },
            (error: any) => {
                console.log("Erro ao buscar nota:", error);
            }
        );
    }

    function consultarSefaz() {
        if (!nota?.chave) return;
        setShowLoading(true);
        setLoadingMessage("Consultando SEFAZ...");
        setStatusSefaz(null);

        requestService(
            fiscalConsultarNFCe.url,
            {
                method: fiscalConsultarNFCe.method,
                body: JSON.stringify({
                    empresaId: loja,
                    chaveAcesso: nota.chave
                }),
                credentials: 'include',
                timeout: 30000
            },
            history,
            (response: any) => {
                setShowLoading(false);
                const dados = response.dados || response;
                // Extrai info do retConsSitNFe se existir
                let cStat = dados.status || '';
                let xMotivo = dados.motivo || '';
                let dhRecbto = '';
                let nProt = '';
                let situacao = dados.situacao || '';
                let status = dados.status || '';
                let chave = dados.chave || nota.chave || '';
                let urlConsulta = dados.urlConsulta || dados.linkConsulta || '';
                if (dados.respostaCompleta?.retConsSitNFe) {
                    const ret = dados.respostaCompleta.retConsSitNFe;
                    cStat = ret.cStat || cStat;
                    xMotivo = ret.xMotivo || xMotivo;
                    dhRecbto = ret.dhRecbto || '';
                    if (ret.protNFe?.infProt) {
                        nProt = ret.protNFe.infProt.nProt || '';
                        if (!dhRecbto) dhRecbto = ret.protNFe.infProt.dhRecbto || '';
                    }
                }
                setStatusSefaz({ cStat, xMotivo, dhRecbto, nProt, situacao, status, chave, urlConsulta });
                setShowStatusModal(true);
            },
            (error: any) => {
                setShowLoading(false);
                mostrarToast(error.message || "Erro ao consultar SEFAZ.", "danger");
            }
        );
    }

    function getUrlConsultaPublica(chave: string, urlConsulta?: string): string {
        if (urlConsulta) return urlConsulta;
        const uf = chave.substring(0, 2);
        const portais: Record<string, string> = {
            "35": `https://www.nfce.fazenda.sp.gov.br/consulta`,
            "41": `https://app.sefaz.pr.gov.br/nfce/qrcode.jsp?chave=${chave}`,
            "43": `https://dfe-portal.svrs.rs.gov.br/Dfe/QrCodeNFce?chave=${chave}`,
            "31": `https://nfce.fazenda.mg.gov.br/portalnfce/sistema/qrcode.xhtml?p=${chave}`,
            "33": `https://www.nfce.fazenda.rj.gov.br/consulta`,
            "42": `https://sat.sef.sc.gov.br/nfce/consulta`,
            "51": `https://www.sefaz.mt.gov.br/nfce/consultanfce`,
            "52": `https://nfceweb.sefazgo.com.br/autentica/qrcode?chave=${chave}`,
            "50": `https://www.dfe.ms.gov.br/nfce/qrcode?chave=${chave}`,
            "29": `https://nfe.sefaz.ba.gov.br/portalnfce/system/qrcode.xhtml?p=${chave}`,
            "23": `https://nfce.sefaz.ce.gov.br/pages/consultarNFCe.html`,
            "26": `https://nfce.sefaz.pe.gov.br/nfce-web/consultarNFCe`,
        };
        return portais[uf] || `https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=completa&nfe=${chave}`;
    }

    function getSefazColor(cStat: string) {
        if (cStat === "100") return "ok";
        if (cStat === "101" || cStat === "110") return "error";
        if (cStat) return "warning";
        return "";
    }

    function getSefazLabel(cStat: string) {
        if (cStat === "100") return "Autorizada";
        if (cStat === "101") return "Cancelada";
        if (cStat === "110") return "Uso Denegado";
        if (cStat === "217") return "Não consta";
        if (cStat === "999") return "Erro interno";
        return "Outro";
    }

    function reimprimir() {
        if (!nota?.chave || !loja) return;
        setLoadingReimprimir(true);
        setShowLoading(true);
        setLoadingMessage("Gerando cupom fiscal...");

        requestService(
            fiscalReimprimirNFCe.url,
            {
                method: fiscalReimprimirNFCe.method,
                body: JSON.stringify({
                    empresaId: loja,
                    chave: nota.chave
                }),
                credentials: 'include',
                timeout: 30000
            },
            history,
            (response: any) => {
                setShowLoading(false);
                setLoadingReimprimir(false);
                if (response?.cupomFiscal?.cupomFiscalUrl) {
                    window.open(response.cupomFiscal.cupomFiscalUrl, '_blank');
                } else {
                    mostrarToast("Não foi possível gerar o cupom fiscal.", "warning");
                }
            },
            (error: any) => {
                setShowLoading(false);
                setLoadingReimprimir(false);
                mostrarToast(error?.mensagem || error?.message || "Erro ao reimprimir NFC-e.", "danger");
            }
        );
    }

    function iniciarCancelamento() {
        if (!nota) return;

        // Verificar se a nota pode ser cancelada (até 24h)
        const dataEmissao = new Date(nota.dataEmissao || nota.createdAt);
        const agora = new Date();
        const diffHoras = (agora.getTime() - dataEmissao.getTime()) / (1000 * 60 * 60);

        if (diffHoras > 24) {
            mostrarToast("NFC-e só pode ser cancelada em até 24 horas após emissão.", "warning");
            return;
        }

        setJustificativa("");
        setShowJustificativaModal(true);
    }

    function confirmarCancelamento(texto?: string) {
        const textoFinal = texto ?? justificativa;
        if (textoFinal.length < 15) {
            mostrarToast("A justificativa deve ter no mínimo 15 caracteres.", "warning");
            return;
        }

        setShowJustificativaModal(false);
        setShowLoading(true);
        setLoadingMessage("Cancelando NFC-e...");

        requestService(
            fiscalCancelarNFCe.url,
            {
                method: fiscalCancelarNFCe.method,
                body: JSON.stringify({
                    empresaId: loja,
                    nfceId: nota.id || nota.nfceId,
                    chaveAcesso: nota.chave,
                    protocolo: nota.protocolo,
                    justificativa: textoFinal
                }),
                credentials: 'include',
                timeout: 30000
            },
            history,
            (response: any) => {
                setShowLoading(false);
                mostrarToast("NFC-e cancelada com sucesso!", "success");
                setNota({ ...nota, status: "CANCELADA" });
            },
            (error: any) => {
                setShowLoading(false);
                mostrarToast(error.message || "Erro ao cancelar NFC-e.", "danger");
            }
        );
    }

    function copiarChave() {
        if (nota?.chave) {
            navigator.clipboard.writeText(nota.chave).then(() => {
                mostrarToast("Chave copiada!", "success");
            });
        }
    }

    function compartilhar() {
        if (navigator.share && nota) {
            navigator.share({
                title: `NFC-e nº ${nota.numero}`,
                text: `Chave de acesso: ${nota.chave}`,
            }).catch(() => { });
        }
    }

    function formatarValor(valor: number) {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency', currency: 'BRL'
        }).format(valor || 0);
    }

    function formatarData(data: string) {
        if (!data) return "";
        return new Date(data).toLocaleDateString('pt-BR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    }

    function getStatusClass(status: string) {
        if (!status) return "";
        const s = status.toUpperCase();
        if (s.includes("AUTORIZADA")) return "autorizada";
        if (s.includes("CANCELADA")) return "cancelada";
        if (s.includes("INUTILIZADA")) return "inutilizada";
        return "";
    }

    function isAutorizada() {
        return nota?.status?.toUpperCase()?.includes("AUTORIZADA");
    }

    function mostrarToast(msg: string, color: string) {
        setTextToast(msg);
        setToastColor(color);
        setShowToast(true);
    }

    if (!nota) {
        return (
            <IonPage className="fiscal-detalhes-page">
                <IonHeader className="ion-no-border">
                    <IonToolbar className="fiscal-detalhes-toolbar">
                        <IonButtons slot="start">
                            <IonBackButton icon={arrowBack} text='' />
                        </IonButtons>
                        <IonTitle>Detalhes da Nota</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="fiscal-detalhes-container">
                    <div className="fiscal-detalhes-empty">
                        <IonIcon icon={documentTextOutline} aria-hidden="true" />
                        <h1>Nota não encontrada</h1>
                        <p>Volte ao histórico e selecione uma nota para consultar os detalhes.</p>
                    </div>
                </IonContent>
            </IonPage>
        );
    }

    return (
        <IonPage className="fiscal-detalhes-page">
            <IonHeader className="ion-no-border">
                <IonToolbar className="fiscal-detalhes-toolbar">
                    <IonButtons slot="start">
                        <IonBackButton icon={arrowBack} text='' />
                    </IonButtons>
                    <IonTitle>NFC-e nº {nota.numero || "—"}</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="fiscal-detalhes-container">
                <div className="fiscal-detalhes-inner">
                    <div className="fiscal-detalhes-heading">
                        <div>
                            <h1>Detalhes da NFC-e</h1>
                            <p>Consulte os dados, a situação e os documentos da nota fiscal.</p>
                        </div>
                        <div className="fiscal-detalhes-status">
                            <GridStatus tone={getStatusClass(nota.status) === 'autorizada' ? 'success' : 'neutral'}
                                icon={getStatusClass(nota.status) === 'autorizada' ? checkmarkCircleOutline : closeCircleOutline}>
                                {nota.status || "—"}
                            </GridStatus>
                            <p>Emissão: {formatarData(nota.dataEmissao || nota.createdAt)}</p>
                        </div>
                    </div>
                    <div className="fiscal-detalhes-summary">
                {/* Dados Gerais */}
                <IonCard className="fiscal-detalhes-card">
                    <IonCardContent>
                        <h2 className="card-title"><IonIcon icon={documentTextOutline} aria-hidden="true" />Dados da nota</h2>
                        <div className="fiscal-detalhe-row">
                            <span className="fiscal-detalhe-label">Número</span>
                            <span className="fiscal-detalhe-value">{nota.numero || "—"}</span>
                        </div>
                        <div className="fiscal-detalhe-row">
                            <span className="fiscal-detalhe-label">Série</span>
                            <span className="fiscal-detalhe-value">{nota.serie || "1"}</span>
                        </div>
                        <div className="fiscal-detalhe-row">
                            <span className="fiscal-detalhe-label">Protocolo</span>
                            <span className="fiscal-detalhe-value">{nota.protocolo || "—"}</span>
                        </div>
                        <div className="fiscal-detalhe-row">
                            <span className="fiscal-detalhe-label">Valor Total</span>
                            <span className="fiscal-detalhe-value">{formatarValor(nota.valorTotal)}</span>
                        </div>
                    </IonCardContent>
                </IonCard>

                {/* Chave de Acesso */}
                {nota.chave && (
                    <IonCard className="fiscal-detalhes-card">
                        <IonCardContent>
                            <h2 className="card-title"><IonIcon icon={copyOutline} aria-hidden="true" />Chave de acesso</h2>
                            <div className="fiscal-chave-acesso">{nota.chave}</div>
                            <div className="fiscal-chave-acoes">
                                <IonButton expand="block" fill="outline" onClick={copiarChave}>
                                    <IonIcon slot="start" icon={copyOutline} />
                                    Copiar
                                </IonButton>
                                <IonButton expand="block" fill="outline" onClick={compartilhar}>
                                    <IonIcon slot="start" icon={shareOutline} />
                                    Compartilhar
                                </IonButton>
                            </div>
                        </IonCardContent>
                    </IonCard>
                )}

                    </div>

                {/* Itens */}
                {nota.itens && nota.itens.length > 0 && (
                    <IonCard className="fiscal-detalhes-card">
                        <IonCardContent>
                            <h2 className="card-title">Itens da nota</h2>
                            <div className="fiscal-itens-scroll" role="region" aria-label="Itens da nota" tabIndex={0}>
                            <table className="fiscal-itens-table">
                                <thead>
                                    <tr>
                                        <th>Produto</th>
                                        <th className="text-right">Qtd</th>
                                        <th className="text-right">Unit.</th>
                                        <th className="text-right">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {nota.itens.map((item: any, idx: number) => (
                                        <tr key={idx}>
                                            <td>{item.descricao || item.nome}</td>
                                            <td className="text-right">{item.quantidade}</td>
                                            <td className="text-right">{formatarValor(item.valorUnitario)}</td>
                                            <td className="text-right">{formatarValor(item.valorTotal || (item.quantidade * item.valorUnitario))}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            </div>
                        </IonCardContent>
                    </IonCard>
                )}

                {/* Pagamentos */}
                {nota.pagamentos && nota.pagamentos.length > 0 && (
                    <IonCard className="fiscal-detalhes-card">
                        <IonCardContent>
                            <h2 className="card-title">Pagamentos</h2>
                            {nota.pagamentos.map((pag: any, idx: number) => (
                                <div className="fiscal-detalhe-row" key={idx}>
                                    <span className="fiscal-detalhe-label">{pag.tipo || pag.descricao}</span>
                                    <span className="fiscal-detalhe-value">{formatarValor(pag.valor)}</span>
                                </div>
                            ))}
                        </IonCardContent>
                    </IonCard>
                )}


                <section className="fiscal-detalhes-actions" aria-label="Ações da nota">
                    <div className="fiscal-action-buttons">
                    {isAutorizada() && (
                        <IonButton expand="block" fill="outline" onClick={reimprimir} disabled={loadingReimprimir}>
                            <IonIcon slot="start" icon={printOutline} />
                            Reimprimir Cupom Fiscal
                        </IonButton>
                    )}

                    <IonButton expand="block" fill="outline" onClick={consultarSefaz}>
                        <IonIcon slot="start" icon={searchOutline} />
                        Consultar na SEFAZ
                    </IonButton>

                    </div>
                    {isAutorizada() && (
                        <div className="fiscal-detalhes-cancelamento">
                        <div><h2>Cancelamento da nota</h2><p>Informe uma justificativa para solicitar o cancelamento.</p></div>
                        <IonButton disabled={acessos?.fiscal != 'edicao'} expand="block" color="danger" fill="outline" onClick={iniciarCancelamento}>
                            <IonIcon slot="start" icon={closeCircleOutline} />
                            Cancelar NFC-e
                        </IonButton>
                        </div>
                    )}
                </section>
                </div>

                {/* Modal situação SEFAZ */}
                <IonModal className="fullscreen-modal fiscal-detalhes-modal" isOpen={showStatusModal} onDidDismiss={() => setShowStatusModal(false)}>
                    <ModalHeader title="Situação na SEFAZ" onDismiss={() => setShowStatusModal(false)} />
                    <IonContent className="fiscal-detalhes-modal-content">
                        {statusSefaz && (
                            <div className="fiscal-detalhes-modal-inner">
                                <div className="fiscal-sefaz-status">
                                    <GridStatus tone={getSefazColor(statusSefaz.cStat) === 'ok' ? 'success' : getSefazColor(statusSefaz.cStat) === 'error' ? 'neutral' : 'warning'}
                                        icon={getSefazColor(statusSefaz.cStat) === 'ok' ? checkmarkCircleOutline
                                            : getSefazColor(statusSefaz.cStat) === 'error' ? closeCircleOutline : warningOutline}>
                                        {getSefazLabel(statusSefaz.cStat)}
                                    </GridStatus>
                                    <p>{statusSefaz.situacao || statusSefaz.status || ''}</p>
                                </div>
                                <IonCard className="fiscal-detalhes-card">
                                    <IonCardContent>
                                        <div className="fiscal-detalhe-row">
                                            <span className="fiscal-detalhe-label">Código</span>
                                            <span className="fiscal-detalhe-value">{statusSefaz.cStat || '—'}</span>
                                        </div>
                                        <div className="fiscal-detalhe-row">
                                            <span className="fiscal-detalhe-label">Motivo</span>
                                            <span className="fiscal-detalhe-value">{statusSefaz.xMotivo || '—'}</span>
                                        </div>
                                        <div className="fiscal-detalhe-row">
                                            <span className="fiscal-detalhe-label">Data/hora</span>
                                            <span className="fiscal-detalhe-value">{statusSefaz.dhRecbto ? formatarData(statusSefaz.dhRecbto) : '—'}</span>
                                        </div>
                                        <div className="fiscal-detalhe-row">
                                            <span className="fiscal-detalhe-label">Protocolo</span>
                                            <span className="fiscal-detalhe-value">{statusSefaz.nProt || '—'}</span>
                                        </div>

                                        <div className="fiscal-detalhe-row">Chave de Acesso</div>
                                        <div className="fiscal-chave-acesso">{statusSefaz.chave || '—'}</div>
                                        <div className="fiscal-chave-acoes">
                                            <IonButton expand="block" fill="outline" onClick={copiarChave}>
                                                <IonIcon slot="start" icon={copyOutline} />
                                                Copiar
                                            </IonButton>
                                        </div>
                                    </IonCardContent>
                                </IonCard>

                                {statusSefaz.chave && (
                                    <IonButton expand="block" fill="outline" style={{ marginTop: 16 }}
                                        onClick={() => window.open(getUrlConsultaPublica(statusSefaz.chave, statusSefaz.urlConsulta), '_blank')}>
                                        <IonIcon slot="start" icon={openOutline} />
                                        Abrir portal da SEFAZ
                                    </IonButton>
                                )}
                            </div>
                        )}
                    </IonContent>
                </IonModal>

                {/* Modal de justificativa para cancelamento */}
                <IonAlert
                    isOpen={showJustificativaModal}
                    onDidDismiss={() => setShowJustificativaModal(false)}
                    header={`Cancelar NFC-e nº ${nota.numero}`}
                    message="Informe a justificativa (mínimo 15 caracteres):"
                    inputs={[
                        {
                            name: 'justificativa',
                            type: 'textarea',
                            placeholder: 'Motivo do cancelamento...',
                            attributes: { minlength: 15 }
                        }
                    ]}
                    buttons={[
                        { text: 'Voltar', role: 'cancel' },
                        {
                            text: 'Cancelar NFC-e',
                            handler: (data) => {
                                const texto = data.justificativa || "";
                                if (texto.length < 15) {
                                    mostrarToast("Justificativa deve ter no mínimo 15 caracteres.", "warning");
                                    return false;
                                }
                                setJustificativa(texto);
                                confirmarCancelamento(texto);
                            }
                        }
                    ]}
                />

                <IonLoading isOpen={showLoading} message={loadingMessage} />

                <IonToast
                    isOpen={showToast}
                    position="top"
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                    color={toastColor}
                />
            </IonContent>
        </IonPage>
    );
};

export default FiscalDetalhes;
